import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

export interface Service {
  name: string;
  used: number;
  total: number;
}

@Component({
  selector: "app-request-service",
  templateUrl: "./request-service.component.html",
  styleUrls: ["./request-service.component.scss"],
})
export class RequestServiceComponent {
  services: Service[] = [
    { name: "Cupping", used: 0, total: 1 },
    { name: "Inbody", used: -1, total: 1 },
    { name: "Massage", used: 1, total: 1 },
    { name: "Meditation", used: 1, total: 1 },
    { name: "Nutrations", used: 1, total: 1 },
    { name: "PTSessions", used: 1, total: 1 },
    { name: "Training", used: 1, total: 1 },
    { name: "Fitness", used: 1, total: 1 },
    { name: "KidsArea", used: 1, total: 1 },
  ];

  constructor(private dialogRef: MatDialogRef<RequestServiceComponent>) {}

  selectService(service: Service): void {
    // handle service selection logic here
  }

  close(): void {
    this.dialogRef.close();
  }
}
